import cn from 'clsx';
import type {ElementType} from 'react';

import {type TypographyVariant, typographyVariants} from '@/components/Typography';

interface RichTextProps {
    html?: string;
    as?: ElementType;
    variant?: TypographyVariant;
    className?: string;
}

const RichText = ({html, as: Tag = 'span', variant, className}: RichTextProps) => {
    if (!html) return null;

    return (
        <Tag
            className={cn(variant && typographyVariants[variant], className)}
            dangerouslySetInnerHTML={{__html: html}}
        />
    );
};

export default RichText;
